import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IUpdateFormMeta } from '@Modules/interfaceManagement/interface/containers/formHandlers/interface/update/UpdateMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';

type Props = {
  onSubmit: any,
  meta: IUpdateFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const UpdateFormUI = ({ meta, onSubmit, isSubmitting, isLoading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      <CC.Box mt="2%" as="fieldset"
      p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'} w={{base: 'full'}}>
        <CC.Heading px={2} as={"legend"} fontSize='md'>
          Parametres généraux
        </CC.Heading>
        <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={2}>
          {displayCustomInputs<IUpdateFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [
              'interfaceType', 
              'interfaceCode',
              'identifier',
              'name',
              'status',
              'lastUpTime',
              'lastDownTime',
              'processIdentifier',
              'numberOfThreads',
              'startScript',
              'stopScript',
              'numberOfProcesses',
            ]
          )}
        </CC.SimpleGrid>
      </CC.Box>

      <CC.Box mt="2%" as="fieldset"
      p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'} w={{base: 'full'}}>
        <CC.Heading px={2} as={"legend"} fontSize='md'>
          Parametres de communication
        </CC.Heading>
        <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={2}>
          {displayCustomInputs<IUpdateFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [
              'primaryAddress',
              'secondaryAddress',
              'primaryPort',
              'secondaryPort',
              'destinationAccessPoint',
              'sourceAccessPoint',
              'debitNetworkIdentifier',
              'timeOutAcquirer',
              'timeOutIssuer',
              'reconnectFlag',
              'numberOfReconnectionAttempts',
              'timeBetweenTwoAttempts',
            ]
          )}
        </CC.SimpleGrid>
      </CC.Box>

      <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} mt={10}>
        {displayCustomInputs<IUpdateFormMeta>(
          meta,
          register,
          errors,
          isLoading,
          [
            'fchTrace',
            'level',
            'incomingMessage',
            'outgoingMessage',
            'refreshMethod',
            'maxTraceSize',
          ]
        )}
      </CC.SimpleGrid>
      
      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default UpdateFormUI;
